import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API, withCredentials: true });

// Bearer fallback: works even when third-party cookies are blocked (vercel.app → onrender.com).
api.interceptors.request.use((config) => {
  try {
    const token = localStorage.getItem("av_token");
    if (token) config.headers.Authorization = `Bearer ${token}`;
  } catch (e) {
    /* localStorage unavailable — cookie path still applies */
  }
  return config;
});

export const fmtINR = (n) => `₹${Number(n || 0).toLocaleString("en-IN")}`;
export const fmtNum = (n) => Number(n || 0).toLocaleString("en-IN");
export const timeAgo = (iso) => {
  if (!iso) return "";
  const d = (Date.now() - new Date(iso).getTime()) / 1000;
  if (d < 60) return "just now";
  if (d < 3600) return `${Math.floor(d / 60)}m ago`;
  if (d < 86400) return `${Math.floor(d / 3600)}h ago`;
  return `${Math.floor(d / 86400)}d ago`;
};

export const parseCSV = (text) => {
  const lines = text.trim().split(/\r?\n/);
  if (lines.length < 2) return [];
  const headers = lines[0].split(",").map((h) => h.trim().toLowerCase().replace(/\s+/g, "_"));
  return lines.slice(1).map((l) => {
    const cells = l.split(",").map((c) => c.trim());
    return Object.fromEntries(headers.map((h, i) => [h, cells[i] || ""]));
  });
};
